import logoHorizontal from "@/assets/brand/logo-horizontal.webp";
import logoHorizontalLight from "@/assets/brand/logo-horizontal-light.webp";
import logoStacked from "@/assets/brand/logo-stacked.webp";
import logoStackedLight from "@/assets/brand/logo-stacked-light.webp";
import logoMark from "@/assets/brand/logo-mark.webp";

type Props = {
  /** `horizontal` for bars, `stacked` for large placements, `mark` for the sunburst alone. */
  layout?: "horizontal" | "stacked" | "mark";
  /** `light` renders the logotype in white for navy backgrounds. */
  tone?: "default" | "light";
  className?: string;
  alt?: string;
  priority?: boolean;
};

/* Intrinsic sizes of the exported assets (from src/public/assets/lucentia-logo.png). */
const SIZES = {
  horizontal: { width: 344, height: 112 },
  stacked: { width: 440, height: 376 },
  mark: { width: 257, height: 256 },
} as const;

export function Logo({ layout = "horizontal", tone = "default", className = "", alt = "Lucentia Social", priority }: Props) {
  const src =
    layout === "mark"
      ? logoMark
      : layout === "stacked"
        ? tone === "light"
          ? logoStackedLight
          : logoStacked
        : tone === "light"
          ? logoHorizontalLight
          : logoHorizontal;
  const { width, height } = SIZES[layout];
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      decoding="async"
      loading={priority ? "eager" : "lazy"}
      {...(priority ? { fetchPriority: "high" as const } : {})}
      className={`h-auto select-none ${className}`}
      draggable={false}
    />
  );
}
